<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输关键字"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;init()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="knoticeTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="title"
                       width="150"
                       label="标题">
      </el-table-column>
      <el-table-column prop="state"
                       width="150"
                       label="公告状态">
        <template slot-scope="scope">
          <span v-if="scope.row.state == 1">发布</span>
          <span v-if="scope.row.state == 2">未发布</span>
        </template>
      </el-table-column>
      <el-table-column prop="content"
                       label="内容">
      </el-table-column>
      <el-table-column label="操作"
                       width="120"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link :underline="false"
                   title="查看"
                   @click="view_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-view"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     width="1000px"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadNoticeList()}">
      </es-pagination>
    </div>
    <!--编辑知识库-->
    <!-- fullscreen="true" -->
    <el-dialog :visible.sync="editVisible"
               width="1000px"
               @closed="()=>{this.$refs['noticeForm'].clearValidate();this.$refs.myEditor.editor.txt.clear();this.fileList = [];}">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑知识库
      </span>
      <el-form :model="noticeInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="100px"
               ref="noticeForm">

        <el-form-item prop="state"
                      label="公告状态">
          <el-col :span="7">
            <el-select v-model="noticeInfo.state"
                       style="display: block;"
                       placeholder="公告状态">
              <el-option label="发布"
                         value="1"></el-option>
              <el-option label="未发布"
                         value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item prop="title"
                      label="公告标题">
          <el-col :span="7">
            <el-input size="small"
                      v-model="noticeInfo.title"
                      placeholder="请输入标题"
                      width="200px"
                      clearable>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item prop="title"
                      label="公告图标">
          <el-col :span="23">
            <es-img :info="noticeInfo"
                    v-if="editVisible"
                    :fileList="fileList"
                    busCode="notice"
                    dataUrl="/base/notice/edit_attach_imgs"
                    type="edit"
                    :max="1"
                    tip="图片大小不能超过5MB。"
                    @insertAttachImgs="(attachImgs)=>{this.$set(this.noticeInfo, 'attachImgs', attachImgs)}"></es-img>
          </el-col>
        </el-form-item>
        <el-form-item label="公告内容"
                      prop="content">
          <el-col :span="23">
            <eswangEditor ref="myEditor"
                          class="myEditor"
                          @sendEditor="sendEditor"
                          :key="$route.fullPath" />
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false;this.fileList = []">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitNotice()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="viewVisible"
               width="1000px"
               @closed="()=>{this.activeName='web';}">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>预览知识库
      </span>
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="web端"
                     name="web">
          <el-container>
            <el-scrollbar style="height: 700px;width: 100%;">
              <el-main v-html="noticeInfo.content">
              </el-main>
            </el-scrollbar>
          </el-container>
        </el-tab-pane>
        <el-tab-pane label="手机端"
                     name="mobile">
          <el-container direction="horizontal"
                        style="width:100%;">
            <el-scrollbar class="el-scrollbar-main-mobile">
              <el-main class="el-scrollbar-main-mobile-context"
                       v-html="noticeInfo.content">
              </el-main>
            </el-scrollbar>
          </el-container>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button size="mini"
                   @click="()=>{this.activeName='web';this.viewVisible = false}">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import eswangEditor from "../common/es-wangEditor.vue";
export default {
  components: {
    eswangEditor,
  },
  name: 'notice',
  props: ["funcs"],
  data () {
    return {
      dialogTile: "新建知识库",
      activeName: "web",
      viewVisible: false,
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      noticeList: [{ "id": "5", "url": "/file/file/down?filename=/asset/imgs/2022-09-19/微信图片_20210205111527_1_1663578093729.jpg", "name": "微信图片_20210205111527_1_1663578093729.jpg" }, { "id": "5", "url": "/file/file/down?filename=/asset/imgs/2022-09-19/微信图片_20210205111533_1_1663578096596.jpg", "name": "微信图片_20210205111533_1_1663578096596.jpg" }],
      editVisible: false,
      noticeInfo: {},//系统信息
      rules: {//验证条件
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        state: [
          { required: true, message: '选择状态', trigger: 'blur' }
        ],
        // content: [
        //   { required: true, message: '请填写内容', trigger: 'blur' }
        // ],
        // attachImgs: [
        //   { required: true, message: '请选择图片', trigger: 'blur' }
        // ]
      },
      equiTypeOptions: [],
      loading: false,
      saving: false,
      fileList: [],
      fileListView: [],
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadNoticeList()
    },
    sendEditor (val) {
      this.noticeInfo.content = val;
    },
    getNoticeById (val) {
      let id = val.id
      if (id != null) {
        this.loading = true;
        this.$ajax
          .get("/base/notice/getNoticeById", { id: id })
          .then((msg) => {
            this.noticeInfo = msg;
            if (msg.attachImgs != null && msg.attachImgs != '') {
              this.fileList = JSON.parse(msg.attachImgs)
              console.log("this.fileList", this.fileList)
              this.fileList.forEach(e => {
                e.url = this.$api + e.url + '&platform=web&token=' + this.$store.getUser().token
              })
            }
            this.$nextTick(() => {
              this.$refs.myEditor.editor.txt.html(this.noticeInfo.content);
            });
            this.loading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    getNoticeByIdView (val) {
      let id = val.id
      if (id != null) {
        this.loading = true;
        this.$ajax
          .get("/base/notice/getNoticeById", { id: id })
          .then((msg) => {
            this.noticeInfo = msg;
            this.loading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    //从后台查询知识库列表
    loadNoticeList () {
      this.loading = true
      this.$ajax.get('/base/notice/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    //初始化添加知识库
    add_init () {
      this.dialogTile = "新建公告"
      this.editVisible = true
      this.noticeInfo = {}
    },
    //初始化知识库
    edit_init (row) {
      this.dialogTile = "编辑公告"
      this.getNoticeById(JSON.parse(JSON.stringify(row)))
      this.editVisible = true
    },
    view_init (row) {
      this.viewVisible = true;
      this.getNoticeByIdView(JSON.parse(JSON.stringify(row)))
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    //保存知识库
    submitNotice () {
      this.$refs["noticeForm"].validate(valid => {
        if (valid) {
          let url = "/base/notice/add";
          if (this.noticeInfo.id != null) {
            url = "/base/notice/edit";
          }
          console.log("submitNotice", this.noticeInfo);
          this.saving = true
          this.$ajax.post(url, this.noticeInfo).then(msg => {
            this.saving = false
            this.loadNoticeList()
            this.editVisible = false
            this.fileList = [];
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除知识库
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["knoticeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/notice/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadNoticeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.editor-bar {
  border: 1px solid #c9d8db;
  border-bottom: 1px solid #c9d8db;
}
.editor-content {
  height: calc(100vh - 00px);
  border: 1px solid #c9d8db;
  border-top: none;
  min-height: calc(100vh - 700px);
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-select-dropdown .el-scrollbar {
  padding-bottom: 17px;
}
.el-scrollbar-main-mobile {
  margin-left: 300px;
  width: 333px;
  height: 700px;
  background-image: url(../../assets/imgs/mobile.png);
}
.el-scrollbar-main-mobile-context {
  margin-left: 26px;
  width: 282px;
  height: 500px;
  margin-top: 98px;
  background-color: white;
}
</style>
